<template style="z-index=1000">
  <el-dialog title="Novo Lançamento Caixa" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form ref="form" :model="detalheLancamento" :rules="validacao" size="small" label-position="top" hide-required-asterisk :show-message="false" style="padding:0;">
      <el-row>
        <el-form-item label="Descrição" prop="descricao">
          <el-input size="small" v-model="lancamento.descricao" :readonly="exibirChequesCaixa"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="Operação" prop="operacao">
          <el-radio-group @change="selecionarOperacao" v-model="lancamento.operacao" style="font-size: small;">
            <el-radio label="ENTRADA" style=" margin-top:5px">Entrada</el-radio>
            <el-radio label="SAIDA" style="margin-top:5px">Saída</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item label="Forma de Pagamento " prop="formaPagamento">
            <el-select @change="selecionarFormaPagamento" v-model="detalheLancamento.formaPagamento" clearable value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in formasPagamento" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Valor" prop="valor" :disabled="lancamento.operacao === 'SAIDA' && detalheLancamento.formasPagamento === 'CHEQUE'">
            <money auto-complete="off" v-model="detalheLancamento.valor" v-bind="money" :readonly="exibirChequesCaixa" class="el-input__inner"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="isVisibleLegendaInformacoesCheque" style="margin-top: 5px">
        <el-col>
          <span style="font-weight: bold">Informações do Cheque:</span>
        </el-col>
      </el-row>

      <el-row v-if="isVisibleLegendaSelecioneCheque" style="margin-top: 5px">
        <el-col :span="6">
          <span style="font-weight: bold">Selecione o Cheque:</span>
        </el-col>

        <el-col :span="6" :offset="12">
          <el-form-item label="Data do Cheque">
            <el-date-picker
              auto-complete="off"
              v-model="pesquisaCheque.dataCheque"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirFormCheque" style="margin-top: 5px">
        <el-col :span="6">
          <el-form-item label="Banco" prop="bancoCheque">
            <el-select v-model="detalheLancamento.bancoCheque" clearable value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in bancos" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Agência" prop="agenciaCheque">
            <el-input size="small" v-model="detalheLancamento.agenciaCheque"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Nº Cheque" prop="numeroCheque">
            <el-input size="small" v-model="detalheLancamento.numeroCheque"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Data" prop="dataCheque">
            <el-date-picker
              size="small"
              v-model="detalheLancamento.dataCheque"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="isVisibleCheckboxInserirNoContasAReceber" :gutter="10">
        <el-col :span="7">
          <el-form-item label=" " prop="contasReceber">
            <el-checkbox v-model="detalheLancamento.contasReceber">Inserir no Contas a Receber</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="exibirChequesCaixa">
        <el-col :span="24">
          <el-table
            :data="chequesCaixa"
            @row-click="selecionarChequeSaida"
            :empty-text="chequesTableEmptyText"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row>
            <el-table-column label="Banco" prop="bancoCheque" :formatter="getLabelBanco"/>
            <el-table-column label="Agência" prop="agenciaCheque"/>
            <el-table-column label="Nº Cheque" prop="numeroCheque"/>
            <el-table-column label="Data" prop="dataCheque"/>
            <el-table-column label="Valor" prop="valor" width="100">
              <template slot-scope="scope">
                <div style="margin: 2px 0px;">{{ formatarValor(scope.row.valor) }}</div>
              </template> 
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
        <el-button @click="gravarHandler" type="primary" size="small" round class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Util from '../../util/funcoes.js';
import { FORMA_PAGAMENTO_LANCAMENTO_CAIXA, BANCOS } from '../../util/constantes.js';
import { Money } from "v-money";

export default {
  props: {
    caixa: Object,
    saldo: Number,
    visibility: Boolean
  },

  components: {
    Money
  },

  data() {
    return {
      lancamento: {
        descricao: undefined,
        operacao: 'ENTRADA',
        detalhesLancamento: []
      },

      detalheLancamento: {
        dataCheque: Util.hoje()
      },

      isDescricaoPreenchidaAutomaticamente: false,
      
      chequeSaidaSelecionado: undefined,

      validacao: {
        valor: [
          { required: true},
          { type: 'number', min: 0.1}
        ],
        formaPagamento: [{ required: true }],
        bancoCheque: [{ required: true}],
        agenciaCheque: [{ required: true}],
        numeroCheque: [{ required: true, pattern: /^\d+$/}],
        dataCheque: [{ required: true}],
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      pesquisaCheque: {
        dataCheque: Util.hoje(),
      },

      isLoadingCheques: false,
    };
  },

  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado }
    }),
    ...mapState("caixaStore", {
      chequesCaixaRecuperados(state) { return state.chequesCaixa }
    }),

    chequesCaixa() {
      return this.chequesCaixaRecuperados
        .filter(this.filtrarChequePorData);
    },

    chequesTableEmptyText() {
      if(this.isLoadingCheques) {
        return 'Carregando...';
      }

      return 'Nenhum Cheque encontrado';
    },

    formasPagamento() {
      return FORMA_PAGAMENTO_LANCAMENTO_CAIXA;
    },
    bancos() {
      return BANCOS;
    },

    isEntrada() {
      return this.lancamento.operacao === 'ENTRADA';
    },
    isSaida() {
      return this.lancamento.operacao === 'SAIDA';
    },

    isCheque() {
      return this.detalheLancamento.formaPagamento === 'CHEQUE';
    },

    exibirFormCheque() {
      return this.isCheque && this.isEntrada;
    },
    exibirChequesCaixa() {
      return this.isCheque && this.isSaida;
    },

    isVisibleLegendaInformacoesCheque() {
      return this.exibirFormCheque;
    },
    isVisibleLegendaSelecioneCheque() {
      return this.exibirChequesCaixa;
    },
    isVisibleCheckboxInserirNoContasAReceber() {
      return this.isEntrada && this.isCheque;
    },

    util() {
      return Util;
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapMutations('caixaStore', [
      'limparChequesCaixa',
    ]),
    ...mapActions('caixaStore', [
        'gravarLancamento',
        'recuperarChequesCaixa'
    ]),

    selecionarOperacao(operacao) {
      if(operacao === 'SAIDA') {
        this.chequeSaidaSelecionado = undefined;
        this.recuperarChequesCaixaHandler();
      }

      if(operacao === 'SAIDA' && this.isCheque) {
        this.setDescricaoSaidaCheque();
      }

      if((operacao !== 'SAIDA' || !this.isCheque) && this.isDescricaoPreenchidaAutomaticamente) {
        this.limparDescricao();
      }
    },

    selecionarFormaPagamento(formaPagamento) {
      if(formaPagamento === 'CHEQUE' && this.isSaida) {
        this.setDescricaoSaidaCheque();
      }

      if((!this.isSaida || formaPagamento !== 'CHEQUE') && this.isDescricaoPreenchidaAutomaticamente) {
        this.limparDescricao();
      }
    },

    setDescricaoSaidaCheque() {
      this.lancamento.descricao = 'Retirada de cheques';
      this.isDescricaoPreenchidaAutomaticamente = true;
    },

    limparDescricao() {
      this.lancamento.descricao = '';
      this.isDescricaoPreenchidaAutomaticamente = false;
    },

    gravarHandler() {
      if(!this.lancamento.descricao){
        this.exibirAlert("Atenção", "Descrição obrigatória!");
        return
      }

      if(this.lancamento.operacao === 'SAIDA' && this.detalheLancamento.valor > (this.saldo/100)){
        this.exibirAlert("Atenção", "O valor da saída é maior que o saldo disponível em Caixa!");
        return
      }

      if(this.lancamento.operacao === 'SAIDA' && this.detalheLancamento.formaPagamento === 'CHEQUE' && !this.chequeSaidaSelecionado){
        this.$message.warning('Selecione o Cheque');
        return
      }

      this.showLoading()
      this.$refs['form'].validate((valid) => {
        if(valid){
          this.lancamento.caixa = { id: this.caixa.id }

          if(this.lancamento.operacao === 'SAIDA' && this.detalheLancamento.formaPagamento === 'CHEQUE' && this.chequeSaidaSelecionado){
            this.lancamento.valor = this.chequeSaidaSelecionado.valor
            this.lancamento.detalhesLancamento = [this.chequeSaidaSelecionado];
          } else {
            this.lancamento.valor = this.detalheLancamento.valor
            this.lancamento.detalhesLancamento = [this.detalheLancamento];
          }

          this.gravarLancamento(this.lancamento).then(resultado => {
            this.hideLoading()
            switch(resultado.status) {
               case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              case "FALHA":
                this.$message.warning(resultado.mensagem);
                break;
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
            this.fechar()
          })
          .catch(() => {
            this.hideLoading()
            this.$message.error("Não foi possível conectar-se ao servidor");
          });
        } else {
          this.$message.warning("Preencha todos os campos obrigatórios.")

          this.hideLoading()
        }
      });
    },

    recuperarChequesCaixaHandler(){
      const payload = {};
      this.showLoadingCheques();

      this.recuperarChequesCaixa(payload)
        .then()
        .finally(() => {
          this.hideLoadingCheques();
        });
    },

    filtrarChequePorData(cheque) {
      const data = cheque.dataCheque;
      if(!data) {
        return true;
      }

      const search = this.pesquisaCheque.dataCheque;
      if(!search) {
        return true;
      }

      return this.isMesmaData(data, search);
    },

    isMesmaData(data1, data2) {
      return Util.compararDatas(data1, data2) === 0;
    },

    showLoadingCheques() {
      this.isLoadingCheques = true;
    },
    hideLoadingCheques() {
      this.isLoadingCheques = false;
    },

    // UTIL
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    getLabelBanco(item) {
      return this.util.getLabel(BANCOS,item.bancoCheque)
    },
    formatarValor(item) {
      return this.util.formatarValor(item)
    },
    selecionarChequeSaida(item) {
      this.chequeSaidaSelecionado = item
      this.detalheLancamento.valor = item.valor
    },

    limparCampos() {
      this.lancamento = {
        descricao: undefined,
        operacao: 'ENTRADA',
        detalhesLancamento: []
      }

      this.detalheLancamento = {
        dataCheque: Util.hoje()
      }

      this.isDescricaoPreenchidaAutomaticamente = false;

      this.isLoadingCheques = false;

      this.limparChequesCaixa();

      this.pesquisaCheque = {
        dataCheque: Util.hoje(),
      };
    },
    fechar() {
      this.limparCampos()
      this.$emit('close');
    } 
  }
}
</script>
